import { PageContent } from "./components/layout/PageContent";
import { HomePage } from "./pages/HomePage";
import { Redirect } from "./components/Redirect";
import { ProfilePage } from "./pages/ProfilePage";
import { ScanPage } from "./pages/ScanPage";
import {
  forAdmin,
  forAuthenticated,
  forCompanyAdmin,
  forNotAuthenticated,
  forRoles,
  forTraCertAdmin,
  permissions
} from "./hooks/user";
import { CertificatePage } from "./pages/CertificatePage";
import { CompaniesPage } from "./pages/CompaniesPage";
import { UsersPage } from "./pages/UsersPage";
import { TemplatesPage } from "./pages/TemplatesPage";
import { CompanyPage } from "./pages/CompanyPage";
import { UserPage } from "./pages/UserPage";
import { TemplatePage } from "./pages/TemplatePage";
import { CertificatesPage } from "./pages/CertificatesPage";
import { CertificateAddPage } from "./pages/CertificateAddPage";
import { LoginPage } from "./pages/LoginPage";
import { BillingSettingsPage } from "./pages/BillingSettingsPage";
import { BillingSettingPage } from "./pages/BillingSettingPage";
import { CertificateMapPage } from "./pages/CertificateMapPage";
import { BusinessSectorsPage } from "./pages/BusinessSectorsPage";
import { BusinessSectorPage } from "./pages/BusinessSectorPage";

const routes = [
  {
    component: PageContent,
    routes: [
      {
        path: "/dashboard",
        component: HomePage
      },
      {
        path: "/profile",
        component: (props: any) => forAuthenticated(ProfilePage, props)
      },
      {
        path: "/login",
        component: (props: any) => forNotAuthenticated(LoginPage, props)
      },
      {
        path: "/companies/:companyId",
        component: (props: any) => forTraCertAdmin(CompanyPage, props)
      },
      {
        path: "/company",
        component: (props: any) => forCompanyAdmin(CompanyPage, props)
      },
      {
        path: "/companies",
        component: (props: any) => forTraCertAdmin(CompaniesPage, props)
      },
      {
        path: "/users/:userId",
        component: (props: any) => forAdmin(UserPage, props)
      },
      {
        path: "/users",
        component: (props: any) => forAdmin(UsersPage, props)
      },
      {
        path: "/templates/:templateId",
        component: (props: any) => forTraCertAdmin(TemplatePage, props)
      },
      {
        path: "/templates",
        component: (props: any) => forTraCertAdmin(TemplatesPage, props)
      },
      {
        path: "/businessSectors/:businessSectorId",
        component: (props: any) => forTraCertAdmin(BusinessSectorPage, props)
      },
      {
        path: "/businessSectors",
        component: (props: any) => forTraCertAdmin(BusinessSectorsPage, props)
      },
      {
        path: "/billingSettings/:billingSettingId",
        component: (props: any) => forTraCertAdmin(BillingSettingPage, props)
      },
      {
        path: "/billingSettings",
        component: (props: any) => forTraCertAdmin(BillingSettingsPage, props)
      },
      {
        path: "/scan",
        component: ScanPage
      },
      {
        path: "/certificates/add",
        component: (props: any) => forRoles(CertificateAddPage, props, permissions.manageCertificates)
      },
      {
        path: "/certificates/:certificateId/map",
        component: CertificateMapPage
      },
      {
        path: "/certificates/:certificateId",
        component: CertificatePage
      },
      {
        path: "/certificates",
        component: (props: any) => forRoles(CertificatesPage, props, permissions.manageCertificates)
      },
      {
        path: "/",
        exact: true,
        component: () => Redirect({ to: '/dashboard' })
      },
      {
        path: "*",
        exact: true,
        component: () => Redirect({ to: '/dashboard' })
      }
    ]
  }
];

export default routes;
